import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1930a3c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930a3c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1930a3c4')) {
      api.createRecord('1930a3c4', component.options)
    } else {
      api.reload('1930a3c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1930a3c4&scoped=true", function () {
      api.rerender('1930a3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/index.vue"
export default component.exports